import Button from "../../../../../comps/button";
import Input from "../../../../../comps/input";
import React from "react";
import { AiOutlineReload, AiFillLock, AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

export default function StepThree({
  readData,
  writeData,
  Submit,
  showNewPassword,
  showNewPasswordAgain,
  toggleNewPassword,
  toggleNewPasswordAgain,
}) {
  return (
    <>
      <Input
        placeholder={"סיסמה חדשה"}
        type={showNewPassword ? "text" : "password"}
        icon={<AiFillLock />}
        value={readData("new_password").value}
        onChange={(e) => writeData(e.target.value, "new_password")}
        status={readData("new_password").status}
        helper_text={readData("new_password").helper_text}
        endIcon={
          <span
            onClick={toggleNewPassword}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        }
      />
      <Input
        placeholder={"אישור סיסמה"}
        type={showNewPasswordAgain ? "text" : "password"}
        icon={<AiOutlineReload />}
        value={readData("new_password_again").value}
        onChange={(e) => writeData(e.target.value, "new_password_again")}
        status={readData("new_password_again").status}
        helper_text={readData("new_password_again").helper_text}
        endIcon={
          <span
            onClick={toggleNewPasswordAgain}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            {showNewPasswordAgain ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </span>
        }
      />
      <Button options={"hover_dark"} onClick={Submit}>
        {"שנה סיסמה"}
      </Button>
    </>
  );
}